import React from 'react';
import './Banner.css'

const Banner = () => {
    return (
        <div>
            <img width='100%' className='banner-img img-fluid' src='https://images.unsplash.com/photo-1532581140115-3e355d1ed1de?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80' alt="" />
        </div>
    );
};

export default Banner;